import { Clickable, FormikField, H2, P } from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';

const AddYourDetailsFields = () => (
  <>
    <H2 looksLike="h5" variant="marginBottomSpacer10">
      Add your details (optional)
    </H2>
    <P>
      Share your details below for ahm to contact you about health insurance, discounts, promotions from ahm & partners
      including health and other insurance products and services.
    </P>
    <P variant="marginBottomSpacer8">
      By providing your details below, you are agreeing to the terms of ahm’s{' '}
      <Clickable to={constants.URLS.SALES.PRIVACY}>privacy policy.</Clickable>
    </P>
    <FormikField label="Given name (optional)" maxLength="24" name="name" size="auto" type="text" />
    <FormikField label="Contact number (optional)" name="phone" type="tel" />
    <FormikField label="Email address (optional)" maxLength="255" name="email" type="email" />
  </>
);

export default AddYourDetailsFields;
